export default "__VITE_ASSET__ac5ce046__"